enum TransactionMethodType {
  CREDIT_CARD = "CREDIT_CARD",
  PAYPAL = "PAYPAL",
  GOOGLEPAY = "GOOGLEPAY",
  APPLEPAY = "APPLEPAY",
  ALIPAY = "ALIPAY",
  PAYNOW = "PAYNOW",
  GRABPAY = "GRABPAY",
  WECHATPAY = "WECHATPAY",
  OFFLINE = "OFFLINE",
  LINK = "LINK",
  UNKNOWN = "UNKNOWN"
}

export default TransactionMethodType;
